import React, { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { RoomClassTypeMapping as RoomClassTypeMappingApi, } from '../../../../api/services/next';
import Transfer from "../../../../components/shared/Transfer";

const RoomClassGroupTransfer = ({
    hotelId,
    roomClassId,
    onChange,
}) => {
    const [roomTypes, setRoomTypes] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);

    const loadRoomTypes = useCallback(async (hotelId) => {
        const availableRoomTypes = await RoomClassTypeMappingApi.GetAvailableRoomTypes({
            HotelId: hotelId
        });
        setRoomTypes(availableRoomTypes);
    }, []);

    const loadRoomTypesInGroup = useCallback(async (hotelId, roomClassId) => {
        const roomClassTypes = await RoomClassTypeMappingApi.GetRoomTypesByRoomClassId({
            HotelId: hotelId,
            RoomClassId: roomClassId
        });

        setRoomTypes(prev => [...prev, ...roomClassTypes]);
        setTargetKeys(roomClassTypes.map((x) => x.Id));
    }, []);

    useEffect(() => {
        if (hotelId > 0) {
            loadRoomTypes(hotelId);
        } else {
            setRoomTypes([])
            setTargetKeys([])
        }
    }, [hotelId, loadRoomTypes])

    useEffect(() => {
        if (roomClassId > 0 && hotelId > 0) {
            loadRoomTypesInGroup(hotelId, roomClassId);
            loadRoomTypes(hotelId);
        } else {
            setRoomTypes([])
            setTargetKeys([])
        }
    }, [hotelId, roomClassId, loadRoomTypesInGroup]);

    useEffect(() => {
        onChange(targetKeys)
    }, [targetKeys, onChange])

    const searchSelector = useCallback((roomType, searchTerm) =>
        roomType.Name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        roomType.ShortName?.toLowerCase().includes(searchTerm?.toLowerCase()), []);

    const handleGroupChange = useCallback((keys) => {
        setTargetKeys(keys);
    }, []);

    const keySelector = useCallback((roomType) => roomType.Id, []);
    const itemRender = useCallback((roomType) => {
        const name = [];

        if(roomType.ShortName){
            name.push(roomType.ShortName)
        }
        
        if(roomType.Name){
            name.push(roomType.Name)
        }

        return name.join('-')
    }, []);

    return (
        <Transfer
            items={roomTypes}
            itemKeySelector={keySelector}
            itemRender={itemRender}
            targetKeys={targetKeys}
            hasSearch
            searchSelector={searchSelector}
            hasSelectAll
            onTargetKeysChange={handleGroupChange}
        />
    );
};

RoomClassGroupTransfer.propTypes = {
    onChange: PropTypes.func.isRequired,
    hotelId: PropTypes.number,
    roomClassId: PropTypes.number
};

RoomClassGroupTransfer.defaultProps = {
}

export default RoomClassGroupTransfer;